import React, { useState, useEffect } from 'react';
//Components
import PopUp from './PopUp';
import General from './General';
import Tipo from './Tipo';
import LevantarNotificar from './LevantarNotificar';
//Material-UI
import { Button } from '@material-ui/core';
//Icons
import { CirclePlus } from 'tabler-icons-react';
//Context
import { useLlamadas } from './LlamadasContext';

function NuevoTipoLlamada() {
    const { step, setStep, setNuevo, postCallType, clear, newCallType } = useLlamadas();
    const [primaryButton, setPrimaryButton] = useState('Siguiente');
    const [secondaryBtn, setSecondaryBtn] = useState('Cancelar');

    const isStepValid = step === 0 ? !!newCallType?.nombre?.trim() : true;

    const increment = (e) => {
        e.preventDefault();
        if (step < 2) setStep(step + 1);
        else postCallType();
    };

    const secondAction = () => {
        if (step > 0) setStep(step - 1);
        else { setNuevo(false); clear(); }
    };

    useEffect(() => {
        setSecondaryBtn(step > 0 ? 'Atrás' : 'Cancelar');
        setPrimaryButton(step > 1 ? 'Finalizar' : 'Siguiente');
    }, [step]);

    const stepContent =
        step === 0 ? <General /> :
        step === 1 ? <Tipo /> :
                     <LevantarNotificar />;

    const footer = (
        <>
            <Button variant="outlined" color="primary" className="popup-button-s" onClick={secondAction}>
                {secondaryBtn}
            </Button>
            <Button variant="contained" color="primary" className="popup-button-s" onClick={increment} disabled={!isStepValid}>
                {primaryButton}
            </Button>
        </>
    );

    return (
        <PopUp
            name="nuevo"
            buttonClass="actions-add"
            colorButton="default"
            isContained="text"
            textButton={<span className="llamada-btn-content"><CirclePlus size={18} /> Agregar</span>}
            title="Nuevo Tipo de Llamada"
            popupBody={stepContent}
            popupFooter={footer}
        />
    );
}

export default NuevoTipoLlamada;
